import styled from "styled-components";

export const FullScreenLayout = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
`;
